// Shared scroll progress source — avoids React re-renders on scroll,
// preventing forced reflow caused by interleaved layout reads/writes.
export const scrollProgressRef = { current: 0 };
